
import { EventManager } from '../services/event-manager.service';
import { HttpService } from '../services/http.service';
import { CalculatorService } from '../services/calculator.service';
import { ValidationService } from '../services/validation.service';
import { AnalyticsService } from '../services/analytics.service';
import { FormsService } from '../services/forms.service';

export abstract class Base {

	element: Element;
	event: any;
	http: HttpService;
	calculatorService: CalculatorService;
	validationService: ValidationService;
	analyticsService: AnalyticsService;
	formsService: FormsService;

	constructor(element: Element) {

		this.element = element;
		this.event = EventManager.Instance;
		this.http = HttpService.getInstance();
		this.calculatorService = CalculatorService.getInstance();
		this.validationService = ValidationService.getInstance();
		this.analyticsService = AnalyticsService.getInstance();
		this.formsService = FormsService.getInstance();

		this.init();
		this.bindEvents();

	}

	abstract init();

	abstract bindEvents();

}



// WEBPACK FOOTER //
// ./components/base-component.ts